import React from 'react'
import { Canvas } from '@react-three/fiber'
import { OrbitControls, ScrollControls } from '@react-three/drei'
import { useSpring } from '@react-spring/core'
import { a } from '@react-spring/web'
import Overlay from './Overlay'
import Scene from './Scene'

export default function Experience() {
  // This spring controls the background and the svg fill (text color)
  const [{ background, fill }, set] = useSpring({ background: '#f0f0f0', fill: '#202020',currentPage:0 }, [])
  return (
    <a.main className='bql-experience' style={{ background }}>
      <Canvas className="canvas" dpr={[1, 2]}>
        <ScrollControls pages={4}>
          <Scene setBg={set} />
          <OrbitControls enablePan={false} enableZoom={false} maxPolarAngle={Math.PI / 2} minPolarAngle={Math.PI / 2} />
        </ScrollControls>
 
      </Canvas>
      <Overlay fill={fill} />
    </a.main>
  )
}
